export default __webpack_public_path__ + "static/media/b10.19980340.jpg";